import {pipe} from "fp-ts/function"
import {from, Observable} from "rxjs"
import * as OBS from "fp-ts-rxjs/Observable"
import API from "../api"

const BASE_PATH = 'stripe'

export const createIntent = (schoolId: number, transientId: string, enrollmentId: string, email: string): Observable<string> => {
    return pipe(
        from(
            API.post(`${BASE_PATH}`, {}, {
                params: {
                    schoolId,
                    transientId,
                    enrollmentId,
                    email
                }
            })
        ),
        OBS.map((res): string => res.data)
    )
}
